export const classes = {
  wrapper:
    'place-between py-2 pl-6 pr-2 bg-white dark:bg-[#332e43] border-b border-grey-4 dark:border-white/10',
  title: 'font-bold text-xl text-grey-8 dark:text-mauve-1 inline',
  actionsWrapper: 'flex items-center',
  closeButton: 'text-grey-7 dark:text-mauve-2 ml-2',
};
